/**
 * @format
 */
import { api } from '@/scripts/api';

export const DocumentTemplateInsertTagsService = {
    getAll(documentTemplateId) {
        return new Promise((resolve, reject) => {
            const service = `/service/DocumentTags/?$filter=DocumentTemplateId eq ${documentTemplateId}&$expand=QuoteTotalTags`;

            api.get(service).then(resolve).catch(reject);
        });
    },

    get(tagId, documentTemplateId) {
        return new Promise((resolve, reject) => {
            const service = `/service/DocumentTags/?$filter=DocumentTemplateId eq ${documentTemplateId} and Id eq ${tagId}`;

            api.get(service).then(resolve).catch(reject);
        });
    },
};